import { DocumentTitle } from "../../../components/DocumentTitle";
import { Box, Typography } from "@mui/material";
import { AdvisorActivityTable } from "../components/AdvisorActivityTable";

export const AdminAdvisorShares = () => {
    return (
        <>
            <DocumentTitle pageTitle="Admin - Advisor Shares" />
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Advisor Share Management
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Manage activities and share allocations for advisors
                </Typography>
            </Box>
            
            <div className="admin-screen">
                <AdvisorActivityTable />
            </div>
        </>
    );
}; 